import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function oneInputFilledValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,
) {
  const model = control.value;
  let oneInputIsFilled = false;
  let msg : string = '';
  if (!model) {
    return null;
  }
   
  try {
    // Iterate through the model to check if at least one option is true
    const mod = Object.entries(model);
      mod.forEach((entry) => {
        let input_name = entry[0];
        let input_model = entry[1];
        if (input_name !== "total") {
          if (input_model) {
            oneInputIsFilled = true;
          }
        }
      });
  } catch (err) {
    console.warn("oneInputFilledValidator Exception "+err);
  }

  if (!oneInputIsFilled) {
     msg = "At least some data should be entered";
  }

  return !msg
  ? null
  : {
    oneInputFilledValidator: {
      message: msg,
    }
  }
}

